var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96629 1.05448L6.96629 7.64959L9.4498 5.16609C9.86231 4.75442 10.5296 4.75442 10.9412 5.16609C11.3529 5.57776 11.3529 6.24503 10.9412 6.65754L6.65754 10.9412C6.24588 11.3529 5.57776 11.3529 5.16609 10.9412L0.882385 6.65754C0.676551 6.45087 0.573634 6.18176 0.573634 5.91182C0.573634 5.64103 0.676551 5.37193 0.882386 5.16609C1.29405 4.75442 1.96133 4.75442 2.37384 5.16609L4.85734 7.64959L4.85734 1.05448C4.85734 0.472405 5.32975 -2.58783e-07 5.91182 -2.33339e-07C6.49389 -2.07896e-07 6.96629 0.472405 6.96629 1.05448Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.ce3fd4511c30abacc784edf5497740d4.svg";
export { ForwardRef as ReactComponent };